'use client';
import {useEffect, useRef} from "react";
import {Button, FontIcon} from "@/app/_components";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectUserInfo} from "@/app/userSlice";
import {selectShopItems} from "@/app/(pages)/shopItemsSlice";
import {getPaymentItemsAsync, openPaymentAsync} from "@/app/(pages)/paymentItemsAPI";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ShopItem} from "@/app/_api/types/store";
import {PayRecordsDialogFC} from "@/app/(pay)/payRecords/PayRecordsDialogFC";
import {showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import {DriveUtil} from "@/Master/DriveUtil";
import styles from "../(pages)/store/page.module.css";
import Load from "@/app/_components/Load/Load";

type GoldImgUrlProps = {
    [key: number]: string;
}

const goldImgUrl:GoldImgUrlProps = {
    1: "/img/store/mini_coins.webp",
    2: "/img/store/small_coins.webp",
    3: "/img/store/middle_coins.webp",
    4: "/img/store/largest_coins.webp",
}

export default function ShopUI() {
    // const user = useUser();
    const userInfo = useAppSelector(selectUserInfo);

    // 商品配置相关
    const paymentItems = useAppSelector(selectShopItems);
    const dispatch = useAppDispatch();

    // 当前点击商品
    const currentItem = useRef<ShopItem>({} as ShopItem);

    useEffect(() => {
        // if (UserGlobalMgr.hasTokenOk(user.token)){
        if (paymentItems.shopItemsRegularData.length === 0) {
            dispatch(getPaymentItemsAsync({userId: userInfo.userId, itemsType: 1}))
        }
        // }
    }, []);

    const openPayment: () => void = async () => {
        showForceLoading()
        const _currItem = currentItem.current;
        const params = {
            userId: userInfo.userId,
            ..._currItem
        }
        // 调起支付
        dispatch(openPaymentAsync(params));
    }

    const userRecharge = () => {
        openPayment();
    }

    const onGoPay = (item: ShopItem) => {
        // 记录当前点击的商品信息
        currentItem.current = item;
        userRecharge();
    }

    if (paymentItems.shopItemsRegularData.length <= 0) return <Load/>

    return (
        <>
            <div className={styles.page}>
                <div className={styles.title}>
                    <FontIcon
                        icon="s-shop-cart"
                        style={{
                            fontSize: '.7rem',
                            color: '#EB3EFF',
                            verticalAlign: '0'
                        }}
                    />
                    <span style={{marginLeft: '.25rem', fontSize: '0.7rem'}}>STORE</span>
                    <div className={`${styles.history} btn`} onClick={() => {
                        SDialogManagerFC.openDialog(PayRecordsDialogFC,{
                            fcKey:SDialogManagerFC.getFCKey(PayRecordsDialogFC),
                            onClose:(isOk:boolean)=>{
                            }
                        })
                    }}>
                        <div className={styles.record_box}>
                            <FontIcon icon="s-wait2" style={{fontSize: '.55rem'}}/>
                        </div>
                    </div>
                </div>

                <div className={styles.grid_container}>
                    {paymentItems.shopItemsRegularData.length > 0 && paymentItems.shopItemsRegularData.map((item:any) =>
                        <div className={`${styles.grid_item}`} key={item.id}>
                            <div className={`${styles.integral}`}>
                                <div>
                                    <span className={styles.icon_vip}>
                                        <img
                                            style={{marginBottom: "-0.02rem"}}
                                            src="/img/img_vip.webp"
                                            alt=""
                                        />
                                    </span>
                                    <span className={styles.ft_vip}>VIP</span>
                                    <span className={styles.ft_integral}>+{item.vipExperience}</span>
                                </div>
                            </div>
                            <div className={styles.grid_item_content}>
                                <div className={styles.gold_num}>
                                    <div
                                        className={styles.gold_label}
                                        style={{
                                            marginRight: '0.1rem'
                                        }}
                                    >
                                        <img src="/img/ico_gc.png" alt=""/>
                                    </div>
                                    <div>{DriveUtil.ToGcKMBTUnitString(item.gc)}</div>
                                </div>
                                <div style={{height: '1.5rem'}}>
                                    {item.showStyle === 1 && <img className={styles.mini_golds} src={goldImgUrl[item.showStyle]} alt=""/>}
                                    {item.showStyle === 2 && <img className={styles.small_golds} src={goldImgUrl[item.showStyle]} alt=""/>}
                                    {item.showStyle === 3 && <img className={styles.middle_golds} src={goldImgUrl[item.showStyle]} alt=""/>}
                                    {item.showStyle === 4 && <img className={styles.largest_golds} src={goldImgUrl[item.showStyle]} alt=""/>}
                                </div>
                                <div className={`${styles.grid_overflow_wrapper} ${item.showStyle === 1 ? styles.no_bg : ''}`}>
                                    {item.showStyle !== 1 && <>
                                        <span>+Free</span>
                                        <div className={styles.free_mode}><img src="/img/ico_sc.png" alt=""/></div>
                                        <span>
                                            {DriveUtil.ToScString(item.sc)}
                                            -
                                            {DriveUtil.ToScString(item.maxSc)}
                                        </span>
                                    </>}
                                </div>
                            </div>
                            <Button
                                color="#17C147"
                                size="small"
                                block
                                style={{
                                    fontSize: '.6rem',
                                    lineHeight: '.9rem',
                                    fontWeight: 'bold',
                                }}
                                onClick={() => onGoPay(item)}
                            >
                                ${item.money}
                            </Button>
                        </div>)}
                </div>

                <div className={styles.tips}>Payment in USD</div>

            </div>
        </>

    )
}
